import { Component, OnInit, ChangeDetectorRef, Inject } from "@angular/core";
import { ApplyCouponService } from "./service/apply-coupon.service";
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from "@angular/material/bottom-sheet";
import { UtilityService } from "src/app/services/utility.service";
import { UserProfileService } from "src/app/services/user-profile.service";

@Component({
  selector: "app-apply-coupon",
  templateUrl: "./apply-coupon.component.html",
  styleUrls: ["./apply-coupon.component.scss"],
})
export class ApplyCouponComponent implements OnInit {
  offersList: Array<any> = [];
  cartId: string = null;
  cartPrice: number = 0;
  hideApply: boolean;
  headerMessage: string;
  profileDetail: any;
  error: boolean;
  constructor(
    private couponService: ApplyCouponService,
    private bottomSheetRef: MatBottomSheetRef<ApplyCouponComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      price: number;
      cartId: string;
      hideApply: boolean;
      headerMessage: string;
    },
    private changeRef: ChangeDetectorRef,
    private utility: UtilityService,
    private userProfile: UserProfileService
  ) {
    this.getOffers();
    // console.log(data);
    this.cartId = data.cartId;
    this.cartPrice = data.price;
    this.hideApply = data.hideApply;
    this.headerMessage = data.headerMessage;
  }

  ngOnInit(): void {}
  async getOffers() {
    this.profileDetail = await this.userProfile.getProfileDetail();
    console.log(this.profileDetail);
    if (this.profileDetail) {
      let { data }: any = await this.couponService.getOffers().catch((err) => {
        console.log(err);
      });
      this.offersList = [...data];
      if(this.offersList.length==0){
        this.error=true;
      }
      this.changeRef.detectChanges();
      // console.log(this.offersList);
    } else {
      this.utility.openDialog({
        message: "Please login to see best offers !",
        hideCancelButton: true,
      });
    }
  }

  goBack(event) {
    // this.router.navigate([CART.fullUrl]);
    this.bottomSheetRef.dismiss(false);
  }

  async applyCoupon(coupon: any) {
    console.log(coupon);
    let query = {
      cartId: this.cartId,
      couponCode: coupon.couponCode,
      couponType: coupon.couponType,
      price: this.cartPrice,
      transactionApplicable: coupon.transactionApplicable,
      applicableOnFirstOrder: coupon.applicableOnFirstOrder,
    };
    try {
      (window as any).Moengage.track_event("Coupon_Code", {
        "couponCode":coupon.couponCode,               // string value
      });
      let { data } = await this.couponService.validateCoupon(query);

      this.bottomSheetRef.dismiss(coupon);
    } catch (e) {
      let {
        error: { message: errorMessage },
      } = e;
      this.utility.showAlert(errorMessage);
    }
    // console.log(data);
  }
}
